import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import t from '@instructure/quiz-i18n/es/format-message';
import { isScientificNotation, parseScientificNotation, toDecimal } from '@instructure/quiz-scientific-notation';
export var numeric = function numeric(val, options) {
  var defaultMessage = t('must be a number');
  var message = options.message || defaultMessage;
  var decMessage = options.decMessage || t('Must have at least the same number of decimals as precision');
  var sfMessage = options.sfMessage || t('Must have at least the same number of significant figures as precision');
  try {
    if (!isNumeric(val)) {
      return message;
    }
    if (options.requireInteger && !Number.isInteger(Number(val))) {
      var defaultIntMessage = t('must be an integer');
      var intMessage = options.integerMessage || defaultIntMessage;
      return intMessage;
    }
    if (options.min !== void 0 && toDecimal(options.min).greaterThan(toDecimal(val))) {
      var defaultMinMessage = t('must be greater or equal to {min}', options);
      var minMessage = options.minMessage || defaultMinMessage;
      return minMessage;
    }
    if (options.max !== void 0 && toDecimal(options.max).lessThan(toDecimal(val))) {
      var defaultMaxMessage = t('must be less than or equal to {max}', options);
      var maxMessage = options.maxMessage || defaultMaxMessage;
      return maxMessage;
    }
    if (options.type !== void 0 && options.value !== void 0 && options.value !== null) {
      var value = options.value.toString();
      if (options.type === 'decimals') {
        if (Number(val) > decimals(value)) {
          return decMessage;
        }
      } else if (options.type === 'significantDigits') {
        if (Number(val) > significantDigits(value)) {
          return sfMessage;
        }
      }
    }
  } catch (e) {
    console.error(e);
    return message;
  }
};
export function significantDigits(value) {
  if (isScientificNotation(value)) {
    var _parseScientificNotat = parseScientificNotation(value),
      _parseScientificNotat2 = _slicedToArray(_parseScientificNotat, 1),
      mantissa = _parseScientificNotat2[0];
    return significantDigits(mantissa);
  }
  var numericChars = value.replace(/[^\d]/g, '');
  return numericChars.replace(/^0+/, '').length || 1;
}
export function decimals(value) {
  if (isScientificNotation(value)) {
    var _parseScientificNotat3 = parseScientificNotation(value),
      _parseScientificNotat4 = _slicedToArray(_parseScientificNotat3, 1),
      mantissa = _parseScientificNotat4[0];
    return decimals(mantissa);
  }
  var match = value.match(/\.(\d+?)$/);
  return match ? match[1].length : 0;
}
function isNumeric(value) {
  return isScientificNotation(value) || toDecimal(value).isFinite();
}
export default numeric;